export default __webpack_public_path__ + "static/media/Aniruddha.6ee7c042.jpeg";